import React from 'react'
import { PageTitle } from '../../../../../_template/layout/core/PageData'

const BestPractices = () => {
  const loginUserType = localStorage.getItem('type');

  let pageTitle;
  if(loginUserType === 'A'){
    pageTitle = [
      {
        title: 'Agents',
        path: '/agents',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
        {
            title: 'Guide',
            path: '/guide/overview',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];
  }
  else if( loginUserType === 'D'){
    pageTitle = [
      {
        title: 'Agents',
        path: '/agents',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
      
    ];
  }

  
    return (
      <>
        <PageTitle breadcrumbs={pageTitle}>
          Best Practices
        </PageTitle>
        <div>BestPractices</div>
      </>
      
    )
}

export default BestPractices